// LockedQuoteBanner.js
//
// Shown at the top of a quote workspace when the quote is locked by a signed
// agreement (see lib/quoteLock.js). Communicates the lock and hosts the ONLY
// editable control on a locked quote — internal notes — with its own Save button
// so the rep never has to touch the (disabled) input panes below. The parent's
// save handler is responsible for persisting notes-only while locked.
import React from 'react';
import { v3 } from '../lib/styleTokens';

export default function LockedQuoteBanner({ notes, onNotesChange, onSave, saving, reason }) {
  return (
    <div
      style={{
        margin: '10px 24px 0',
        border: '1px solid #fecaca',
        background: '#fef2f2',
        borderRadius: v3.radius.card,
        padding: '12px 14px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 15 }}>🔒</span>
        <span style={{ fontSize: 13, fontWeight: 700, color: '#991b1b' }}>Signed &amp; locked</span>
      </div>
      <div style={{ fontSize: 12, color: '#7f1d1d', marginTop: 4, lineHeight: 1.5 }}>
        {reason || 'This quote has a signed agreement and is locked. Only internal notes can be edited.'}
      </div>
      <div style={{ marginTop: 10 }}>
        <div
          style={{
            fontSize: 10,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '.04em',
            color: '#7f1d1d',
            marginBottom: 4,
          }}
        >
          Internal notes
        </div>
        <textarea
          value={notes || ''}
          onChange={(e) => onNotesChange(e.target.value)}
          rows={3}
          placeholder="Add an internal note about this signed quote…"
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: '8px 10px',
            border: '1px solid #fca5a5',
            borderRadius: v3.radius.input || 6,
            fontSize: 13,
            fontFamily: v3.font.family,
            resize: 'vertical',
            outline: 'none',
            background: '#fff',
          }}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 6 }}>
          <button
            onClick={onSave}
            disabled={saving}
            style={{
              padding: '6px 14px',
              background: saving ? '#fca5a5' : '#b91c1c',
              color: '#fff',
              border: 'none',
              borderRadius: v3.radius.input || 6,
              fontSize: 12,
              fontWeight: 700,
              cursor: saving ? 'default' : 'pointer',
            }}
          >
            {saving ? 'Saving…' : 'Save Notes'}
          </button>
        </div>
      </div>
    </div>
  );
}
